// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.valve-load-error {
  padding: 24px 0;
  color: #97002e;
}

.button-row {
  float: right;
  text-align: right;
}
.button-row .valve-status-section {
  margin-bottom: 6px;
}
.button-row .valve-status-section .valve-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.button-row .valve-status-section .valve-status-badge.valve-status-badge--draft {
  color: #e65100;
  background-color: #fff3e0;
  border: 1px solid #faab18;
}
.button-row .valve-status-section .valve-status-badge.valve-status-badge--retired {
  color: #97002e;
  background-color: #fff0f3;
  border: 1px solid #f4a3b5;
}
.button-row .valve-status-section .valve-status-badge.valve-status-badge--archived {
  color: #8c8f93;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
}

.valve-tag * {
  float: left;
  font-weight: 900;
  color: #0B2D71;
}

.valve-summary-page-header {
  font-weight: 500;
  color: #0B2D71;
}

.from-revision-name {
  margin-bottom: 5%;
}

button {
  font-weight: bolder;
}

.header-table {
  width: 5%;
}

h6 {
  float: left;
}

.last-edited {
  float: right;
}

.title {
  font-size: medium;
  white-space: nowrap;
  padding: 5px 4px;
}

.content {
  font-size: medium;
  white-space: nowrap;
  padding: 5px 4px;
}

.used-in-table {
  width: 100%;
}

.headers {
  font-weight: bolder;
  padding-top: 40px;
  color: #0B2D71;
}

.titles {
  font-weight: bolder;
}

.short-description {
  padding-top: 15px;
  padding-bottom: 15px;
}

.short-pipe-class-description {
  padding-bottom: 15px;
}

.valve-details-mat-accordion {
  padding-bottom: 15px;
}

p {
  font-size: 16px;
}

.used-in-table a {
  color: #0066B2;
  cursor: pointer;
}

.used-in-table th {
  cursor: pointer;
}

/** Keeps the column title and sort icon on a single line regardless of cell width. */
.sort-header {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.faSort {
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}

/** Neutral sort indicator — dimmed to distinguish it from the active sort arrow. */
.faSort-inactive {
  opacity: 0.35;
}

.faSort-active {
  color: #0066b2;
}

.valve-details-mat-accordion table {
  width: 100%;
  border-collapse: collapse;
}

.details-label {
  width: 20%;
  padding: 4px;
  font-weight: bolder;
  color: #696B6D;
  vertical-align: text-top;
  border-bottom: 1px solid #e0e0e0;
}

.details-value {
  width: 80%;
  padding: 4px;
  border-bottom: 1px solid #e0e0e0;
}

.parameters-label {
  width: 22%;
  padding: 2px;
  font-weight: bolder;
  color: #696B6D;
}

.parameters-value {
  width: 78%;
  padding: 4px;
}

.parameters {
  padding: 5px 5px 10px 0px;
}

fa-icon {
  padding: 3px;
}

.back-button {
  margin-bottom: 1.5rem;
  cursor: pointer;
  color: #0066b2;
  border-color: #0066b2;
  background-color: #fff;
  border-radius: 5px;
}

.notes-legend {
  padding: 2% 0;
}

.notes-row {
  display: flex;
  flex-direction: row;
  gap: 2%;
}

.notes-row-title {
  white-space: nowrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
